<template>
  <router-link
    :to="{ name: 'masechta', params: { slug: masechta.url_key } }"
    class="col-md-4 col-sm-6 mb-4 masechta-container"
  >
    <div class="card masechta text-white h-100">
      <h5 class="masechta-title card-header">
        <template v-if="!isRTL">{{ masechta.name }}</template>
        {{ masechta.name_hebrew }}
        <i
          class="fa fa-arrow-right"
          :class="isRTL ? 'float-left' : 'float-right'"
        ></i>
      </h5>
      <div class="card-body">
        <div
          v-for="(sponsor, index) in masechta.masechta_sponsors"
          v-if="masechta.masechta_sponsors.length > 0"
          class="mb-3"
        >
          <template
            v-if="
              sponsor.sponsor_id != 0 && sponsor.sponsor && sponsor.sponsor.name
            "
          >
            <h5 class="card-subtitle muted">
              <template v-if="masechta.masechta_sponsors.length > 1">{{
                $t("volume", { number: sponsor.volume_number })
              }}</template>
              {{ $t("dedicatedBy") }}
            </h5>
            <p class="card-text">{{ sponsor.sponsor.name }}</p>
          </template>
          <template v-if="sponsor.sponsor_id == 0 && sponsor.dedicated_to">
            <h5 class="card-subtitle muted">
              <template v-if="masechta.masechta_sponsors.length > 1">{{
                $t("volume", { number: sponsor.volume_number })
              }}</template>
              {{ $t("dedicatedBy") }}
            </h5>
            <p class="card-text">{{ $t("anonymous") }}</p>
          </template>
          <template v-if="sponsor.dedicated_to">
            <!-- <h5 class="card-subtitle muted">In Memory Of:</h5> -->
            <p class="card-text">{{ sponsor.dedicated_to }}</p>
          </template>
        </div>
      </div>
    </div>
  </router-link>
</template>
<script>
export default {
  props: ["masechta"],
  i18nOptions: {
    namespaces: "components",
    keyPrefix: "masechta",
  },
};
</script>
<style lang="scss" scoped>
.masechta-container {
  &:hover {
    text-decoration: none;
  }
  .masechta {
    .masechta-title {
      background: $dark-blue;
      font-size: 1rem;
    }
    .card-body {
      color: $dark-blue;
      h5 {
        font-size: 1rem;
      }
    }
  }
}
</style>
